import * as React from 'react';
import { MenuListItem } from '../Menu';
import StyleSelect from './StyledSelect';
export default function MiniSelect(props) {
    var value = props.value, onChange = props.onChange;
    return (React.createElement(StyleSelect, { autoWidth: true, wrapperStyle: { alignSelf: 'center' }, value: value, onChange: onChange },
        React.createElement(MenuListItem, { value: 10 }, "10\u6761/\u9875"),
        React.createElement(MenuListItem, { value: 15 }, "15\u6761/\u9875"),
        React.createElement(MenuListItem, { value: 50 }, "50\u6761/\u9875"),
        React.createElement(MenuListItem, { value: 100 }, "100\u6761/\u9875")));
}
//# sourceMappingURL=MiniSelect.js.map